// extracted by mini-css-extract-plugin
export default {"backgroundDropZone":"BackgroundDropZone_backgroundDropZone__HjGTk","backgroundDropZoneTextGroup":"BackgroundDropZone_backgroundDropZoneTextGroup__kUhlr"};